import { render, staticRenderFns } from "./TableDirectorGeneral.vue?vue&type=template&id=af492bea&scoped=true&"
import script from "./TableDirectorGeneral.vue?vue&type=script&lang=js&"
export * from "./TableDirectorGeneral.vue?vue&type=script&lang=js&"
import style0 from "./TableDirectorGeneral.vue?vue&type=style&index=0&id=af492bea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af492bea",
  null
  
)

export default component.exports